document.addEventListener('octane.quiz.completed', function(e) {
  const answers = e.detail.answers;
  console.log(answers);

  // Find the result key (contains 'quiz result') and extract shade name using includes
  const resultKey = Object.keys(answers).find(k => k.toLowerCase().includes('quiz result'));
  if (!resultKey) {
    console.error('Could not find quiz result key in answers:', answers);
    return;
  }

  const resultValue = answers[resultKey]; // e.g. "Speakeasy Shade System"

  const variantMap = {
    'Speakeasy': '45958907887846',
    'Rosy':      '45958907920614',
    'Berry':     '45958907953382',
    'Copper':    '45958907986150',
    'Bare':      '46773415739622'
  };

  // Match shade name using includes since result value is longer e.g. "Speakeasy Shade System"
  const shadeName = Object.keys(variantMap).find(k => resultValue.includes(k));

  if (!shadeName) {
    console.error('No shade matched in result value:', resultValue);
    return;
  }

  const variant    = variantMap[shadeName];
  const skintone   = answers['Octane: What is your skin tone?'];
  const undertone  = answers['Octane: What is your undertone?']; // update key once you confirm undertone question
  const preference = answers['Octane: Pick a shade category you\'re most drawn to:'];
  const name = answers['Octane: Type your name'];

  const url = `https://soshebeauty.com/products/blurring-pillow-blush-brush-combo?variant=${variant}&qr=${shadeName}&skintone=${encodeURIComponent(skintone)}&undertone=${encodeURIComponent(undertone)}&preference=${encodeURIComponent(preference)}&name=${encodeURIComponent(name)}`;
  window.location.href = url;
}, false);